/**
 * Load Voluum lander into form state when dialog opens.
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  type Dispatch,
  type SetStateAction,
  useEffect,
  useState,
} from 'react';

import { getVoluumLander } from '@/features/flow-optimizer/services/voluum-lander-api';

import {
  parseVoluumLanderResource,
  type VoluumLanderFormValues,
} from './map-voluum-lander-form';
import { readHttpErrorMessage } from './read-http-error';

export function useVoluumLanderLoad(
  open: boolean,
  landerId: string,
  setValues: Dispatch<SetStateAction<VoluumLanderFormValues>>,
): { loading: boolean; loadError: string | null } {
  const [loadError, setLoadError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    const id = landerId.trim();
    if (!id) {
      setLoadError('Missing lander id.');
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoadError(null);
    setLoading(true);
    void getVoluumLander(id)
      .then((raw) => {
        if (cancelled) return;
        setValues(parseVoluumLanderResource(raw));
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setLoadError(readHttpErrorMessage(err));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, landerId, setValues]);

  return { loading, loadError };
}
